export enum TutorialType {
    VerifyAttendanceTutorial = 'VerifyAttendanceTutorial',
    GroupcastTutorial = 'GroupcastTutorial',
    Mp3Tutorial = 'Mp3Tutorial',
    Mp4Tutorial = 'Mp4Tutorial',
    Mp3DownloadTutorial = 'Mp3DownloadTutorial',
    Mp4DownloadTutorial = 'Mp4DownloadTutorial',
}

export const tutorialTypeCookiesMap = {
    [TutorialType.VerifyAttendanceTutorial]: 'verifyAttendanceTutorialCookie',
    [TutorialType.GroupcastTutorial]: 'groupcastTutorialCookie',
    [TutorialType.Mp3Tutorial]: 'mp3TutorialCookie',
    [TutorialType.Mp4Tutorial]: 'mp4TutorialCookie',
    [TutorialType.Mp3DownloadTutorial]: '',
    [TutorialType.Mp4DownloadTutorial]: '',
};
